<template>
  <div id="EditCustomRoleAdmin" class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="pageTitle">Update</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-header">{{ name }}</div>
          <div class="card-body">
            <div class="col-md-8">
              <!-- <h3>Please provide Custom Role name</h3> -->
              <!-- Create form -->
              <form @submit.prevent="updateCustomRole">
                <div class="form-group">
                  <label for="name">
                    Custom Role name
                    <span class="text-danger">*</span>
                  </label>
                  <input type="text" v-model="name" class="form-control" :class="{ 'is-invalid': $v.name.$error, 'is-valid': !$v.name.$invalid }" />
                  <div class="invalid-feedback">
                    <span v-if="!$v.name.required">Custom Role name is required.</span>
                    <span v-if="!$v.name.minLength">Custom Role name must be at least {{ $v.name.$params.minLength.min }} letters.</span>
                  </div>
                </div>
                <div class="form-group">
                  <label for="name">Custom Role description</label>
                  <textarea v-model="description" class="form-control" rows="3" />
                </div>
                <button class="btn btn-danger btn-block">Update Custom Role</button>
              </form>
              <!-- / Create form -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "EditCustomRoleAdmin",

  data() {
    return {
      categories: [],
      name: "",
      description: "",
    };
  },

  mounted() {
    let loading = this.$loading.show();
    axios.get(`/admin/custom-role/${this.$route.params.uuid}`).then((res) => {
      this.name = res.data.customRole.name;
      this.description = res.data.customRole.name;
      loading.hide();
    });
  },

  methods: {
    updateCustomRole() {
      let loading = this.$loading.show();
      this.$v.$touch();
      if (this.$v.$invalid) {
        loading.hide();
        return;
      }
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("description", this.description);
      formData.append("uuid", this.$route.params.uuid);
      axios.post("admin/custom-role/edit", formData).then((res) => {
        if (res.data.status == "success") {
          //res.data.custom-role.subCategories = [];
          //this.categories.push(res.data.custom-role);
          this.$swal("", `${this.name} updated successfully`, "success");
          this.$router.push({ name: "CustomRolesAdmin" });
        } else {
          this.$swal("", res.data.message, "error");
        }
        loading.hide();
      });
    },
  },

  computed: {
    client() {
      return this.$store.state.client;
    },
  },

  created() {
    //this.$store.commit("SET_LAYOUT", "agent-layout");
  },

  validations: {
    name: { required, minLength: minLength(2) },
    //description: { minLength: minLength(2) }
  },
};
</script>

